import { ref } from 'vue'

// Module-level singleton refs — shared across all callers. The organizations
// store's loadCallerContext() sets them from GET /admin/me; the router guard
// and the views read them.
const isSuperAdmin = ref(false)
const isSuperAdminLoaded = ref(false)

export function useSuperAdmin() {
  const setSuperAdmin = (value: boolean) => {
    isSuperAdmin.value = value
    isSuperAdminLoaded.value = true
  }

  const resetSuperAdmin = () => {
    isSuperAdmin.value = false
    isSuperAdminLoaded.value = false
  }

  return {
    isSuperAdmin,
    isSuperAdminLoaded,
    setSuperAdmin,
    resetSuperAdmin,
  }
}
